import { withInstall } from '@xzx-design/utils'
import _Circle from './src/circle'

export const Circle = withInstall(_Circle)
export default Circle

export * from './src/circle'
export * from './src/types'
